import { useState, useCallback } from 'react';

import { noticeCache } from 'services/cache';

function useNotice(key: string, initialVisible: boolean = false) {
  const [visible, setVisible] = useState<boolean>(() => {
    const visible = noticeCache.getNotice(key);

    if (visible === null) {
      return initialVisible;
    }

    return visible;
  });
  const update = useCallback(
    (visible: boolean) => {
      if (visible) {
        noticeCache.removeNotice(key);
      } else {
        noticeCache.setNotice(key, visible);
      }

      setVisible(visible);
    },
    [key],
  );

  return {
    visible,
    update,
  };
}

export default useNotice;
